import { render, staticRenderFns } from "./BaseFollowButton.vue?vue&type=template&id=56021d1c&scoped=true&"
import script from "./BaseFollowButton.vue?vue&type=script&lang=js&"
export * from "./BaseFollowButton.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&id=56021d1c&prod&scoped=true&lang=css&"
import style1 from "./BaseFollowButton.vue?vue&type=style&index=1&id=56021d1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56021d1c",
  null
  
)

export default component.exports